import React from 'react';
import { getAssetSrc } from '@frontend/jetlend-web-ui/src/utils/getAssetSrc';
import Image from '@app/components/Image/Image';

import styles from './SpeakerSection.module.scss';

export interface IProps {
    /**
     * Имя эксперта/спикера
     */
    name: string;
    /**
     * Должность
     */
    position: string;
    /**
     * Ссылка на фото эксперта/спикера
     */
    imageUrl: string;
    /**
     * Текст alt тега для фото эксперта/спикера
     */
    imageAlt?: string;
}

/**
 * Компонент для отрисовки карточки спикера
 */
const SpeakerCardItem:React.FC<IProps> = props => {
    const {
        name,
        position,
        imageUrl,
        imageAlt,
    } = props;

    return (
        <div className={styles['card']}>
            <div className={styles['image']}>
                <Image src={getAssetSrc(imageUrl)} alt={imageAlt ?? ''} fill />
            </div>
            <div className={styles['title']}>{name}</div>
            <div className={styles['text']}>{position}</div>
        </div>
    );
};

export default SpeakerCardItem;